import { render } from "./PaginationComponent.vue?vue&type=template&id=65819820"
import script from "./PaginationComponent.vue?vue&type=script&lang=js"
export * from "./PaginationComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/hanlin-lesson-plan/hanlin-lesson-plan/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__